import React, { useState, useEffect } from "react";
import { Offcanvas, Form, ListGroup } from "react-bootstrap";

const SearchDrawer = ({ show, onHide, title, options = [], onSelect }) => {
  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState(options);

  useEffect(() => {
    const s = search.toLowerCase();
    setFiltered(options.filter((opt) => opt.label.toLowerCase().includes(s)));
  }, [search, options]);

  return (
    <Offcanvas show={show} onHide={() => {onHide();setSearch("");}} placement="end" backdrop>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="d-flex flex-column" style={{ height: "100%" }}>
        {/* Search box (fixed at top) */}
        <Form.Control
          type="search"
          placeholder={`Search ${title.toLowerCase()}...`}
          className="mb-3"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* Scrollable list */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          <ListGroup>
            {filtered.map((opt, i) => (
              <ListGroup.Item
                key={i}
                action
                onClick={() => {
                  onSelect(opt); 
                  onHide();
                  setSearch("");
                }}
              >
                <div className="fw-bold">{opt.label}</div>
                {opt.groupLabel && (
                  <small className="text-muted">{opt.groupLabel}</small>
                )}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SearchDrawer;
